{
	setTimeout(() => document.body.classList.add('render'), 60);
	const navigate = (linkEl) => {
		document.body.classList.remove('render');
	};
	document.addEventListener('keydown', (ev) => {
		const keyCode = ev.keyCode || ev.which;
		let linkEl;
		navigate(linkEl);
	});
	imagesLoaded('.glitch__img', { background: true }, () => {
		document.body.classList.add('imgloaded');
	});
}
